import './relation.css'

const Relation = ({relation, data}) => {
      
      const name = relation.name === '' ? data.relation.name : relation.name
      const avatar = relation.avatar === '' ? data.relation.avatar : relation.avatar 
      const about = relation.about === '' ? data.relation.about : relation.about 
      const me = relation.me === '' ? data.relation.me : relation.me

      return (
            <div className="relation_content">
                  <img src={avatar} alt={name} />
                  <div className="relation_data">
                        <strong>{name}</strong>
                        <div className="relation_about">
                              <p>{about}</p>
                        </div>
                        <a href={me} target="_blank" rel="noreferrer">xat.me</a>
                  </div>
            </div>
      )
}

export default Relation
